import { graphClient } from '../graph-client'
import {
  GET_APP_SETTING,
  GET_APP_SETTING_DEFAULT_VALUE,
  GET_APP_SETTING_GAME,
  GET_APP_SETTING_PUSH,
  GET_APP_SETTING_VERSION,
  GET_APP_THEME_FIRST,
  GET_SERVER_DATE,
} from './gql'
import type {
  Get,
  GetAppThemeInUse,
  GetDefaultValue,
  GetGame,
  GetPush,
  GetServerDate,
  GetVersion,
} from './types'

class AppService {
  async getAppSetting() {
    const request = await graphClient.request<Get.Output>(GET_APP_SETTING, {
      appSettingId: 1,
    })

    return request?.getAppSetting
  }

  async getAppSettingVersion() {
    const request = await graphClient.request<GetVersion.Output>(
      GET_APP_SETTING_VERSION,
      {
        appSettingId: 1,
      },
    )

    return request?.getAppSettingVersion
  }

  async getAppSettingPush() {
    const request = await graphClient.request<GetPush.Output>(
      GET_APP_SETTING_PUSH,
      {
        appSettingPushId: 1,
      },
    )

    return request?.getAppSettingPush
  }

  async getAppSettingGame() {
    const request = await graphClient.request<GetGame.Output>(
      GET_APP_SETTING_GAME,
      {
        appSettingGameId: 1,
      },
    )

    return request?.getAppSettingGame
  }

  async getAppSettingDefaultValue() {
    const request = await graphClient.request<GetDefaultValue.Output>(
      GET_APP_SETTING_DEFAULT_VALUE,
      {
        appSettingDefaultValueId: 1,
      },
    )

    return request?.getAppSettingDefaultValue
  }

  async getServerDate() {
    const request =
      await graphClient.request<GetServerDate.Output>(GET_SERVER_DATE)

    return request?.getServerDate
  }

  async getAppThemeInUse(params: GetAppThemeInUse.Input) {
    const request = await graphClient.request<GetAppThemeInUse.Output>(
      GET_APP_THEME_FIRST,
      params,
    )

    return request?.getAppThemeFirst
  }
}

export const appService = new AppService()
